import _get from 'lodash/get';
import React from 'react';
import StatusWithText from 'components/statusWithText';
import { getBalanceTransactionStatus } from 'helpers/status';
const BalanceTransactionStatusCell = ({ status, date, rowData }) => {
    const { text, variant } = getBalanceTransactionStatus(_get(rowData, status));
    return (React.createElement(StatusWithText, { secondaryText: _get(rowData, date), status: variant }, text));
};
export default BalanceTransactionStatusCell;
